<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="nevs-popup-text">
                <NevsTextField v-model="recipients" :label="$LANG.Get('fields.emailRecipients')"></NevsTextField>
                <div v-if="emailCopy !== ''" class="send-email-copy-disclaimer">
                    {{ $LANG.Get('texts.emailCopyDisclaimer').replace('%email%', emailCopy) }}
                </div>
                <p class="predefined-content-disclaimer">{{ $LANG.Get('labels.predefinedContentNote') }}</p>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">{{ $LANG.Get('buttons.cancel') }}</NevsButton>
                <NevsButton class="success" @click="sendClick()">{{ $LANG.Get('buttons.send') }}</NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";

export default {
    name: "ModalSendEmail",
    components: {NevsTextField, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        documentId: {
            type: Number,
            default: null
        },
        customerId: {
            type: Number,
            default: null
        },
        endpoint: {
            type: String,
            default: ''
        }
    },
    emits: ['done'],
    data() {
        return {
            loaded: false,
            recipients: '',
            emailCopy: ''
        }
    },
    watch: {
        show() {
            this.loaded = false;
            this.recipients = '';
            this.emailCopy = this.$store.state.user.client.email_copy ?? '';

            if (this.show) {
                if (this.customerId !== null) {
                    let vm = this;
                    this.$API.APICall('get', 'customers/' + this.customerId, {}, (data, success) => {
                        if (success && data.customer !== null) {
                            let emails = data.customer.emails
                                .filter(e => e.documents)
                                .map(e => e.address);
                            vm.recipients = emails.join(';');
                        }
                        vm.loaded = true;
                    });
                } else {
                    this.loaded = true;
                }
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        sendClick() {
            let vm = this;
            let recipientList = this.recipients
                .split(';')
                .map(e => e.trim())
                .filter(e => e !== '');
            this.$API.APICall('post', this.endpoint + '/email/' + this.documentId, {recipients: recipientList}, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.emailSent'), type: 'alert'});
                    vm.$emit('done', true);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.send-email-copy-disclaimer {
    margin: 5px;
    margin-top: 2px;
    font-size: 0.85em;
    color: #666;
}

.predefined-content-disclaimer {
    margin: 5px;
    margin-top: 8px;
    font-size: 0.85em;
    color: #666;
}
</style>
